<template>
	<div>
    <keep-alive>
      <transition v-if="$route.meta.keepAlive" name="fade-transform" mode="out-in">
        <router-view  v-wechat-title="$route.meta.title" :key="$route.name" />
      </transition>
    </keep-alive>
    <transition v-if="!$route.meta.keepAlive" name="fade-transform" mode="out-in">
      <router-view  v-wechat-title="$route.meta.title" :key="$route.name" />
    </transition>
	</div>
</template>

<script>
export default {
	data() {
		return {}
	},
}
</script>
